import { createFileRoute, notFound } from "@tanstack/react-router";
import { BlogPostPage } from "@/components/blog/BlogPostPage";
import { getPost } from "@/lib/blog";
import { blogPostSeo } from "@/lib/blog-seo";
import { resolveSiteContext } from "@/lib/site";

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ location, params }) => {
    if (!getPost(resolveSiteContext(location.href), params.slug)) {
      throw notFound();
    }
    return { href: location.href };
  },
  head: ({ loaderData, params }) =>
    blogPostSeo(loaderData?.href ?? `/blog/${params.slug}`, params.slug),
  component: BlogPostRoute,
});

function BlogPostRoute() {
  const { slug } = Route.useParams();
  return <BlogPostPage slug={slug} />;
}
